import React from "react";
import styled from "styled-components";
import { path } from "ramda";
import { Row, Col, Card, Divider } from "antd";
import I18n from "../../i18n";
import { OH1 } from "../../components/text/OText";
import { Colors, Metrics } from "../../theme";
import { DataVisualizeKeys } from "../../theme/Colors";
import { isAlive, isFunction, ArrayUtil, DateUtil, RouteUtil } from "../../util";
import DatePickerCompare from "./DatePickerCompare";
import ExportButton from "../../components/button/ExportButton";
import ExportDateRangeModal from "../../components/modal/ExportDateRangeModal";
import ComparePanel from "./ComparePanel";
import UpgradePlanWarning from "../UpgradePlanWarning";

export const HeaderOptionBar = styled.div`
	display:flex;
	justify-content: space-between;
`;

export const CompareCol = ({children, style, isVertical, full = false, noMargin, onClick = undefined, perRow = 2})=>{
	let addedStyle = {...style};
	if(!noMargin){
		addedStyle = {
			marginBottom: Metrics.button.bigSpaceMargin, 
			...addedStyle
		};
	}
	return (<Col 
		style={addedStyle}
		xs={full || isVertical ? undefined : 24} 
		md={full || isVertical ? undefined : 24/perRow}>
		<div onClick={onClick}>
			{children}
		</div>
	</Col>);
};

export const CompareDiv = ({children, style, isVertical, full = false, noMargin, onClick = undefined, perRow = 2})=>{
	let addedStyle = {
		...style,
		position:"relative",
		display:"inline-block",
		width: `${100 / perRow}%`
	};
	if(!noMargin){
		addedStyle = {
			//marginBottom: Metrics.button.bigSpaceMargin, 
			...addedStyle
		};
	}
	return (<div style={addedStyle}>
		<div onClick={onClick}>
			{children}
		</div>
	</div>);
};
export const SubHeader = styled.div`
    font-size:${Metrics.fontSize.bold}px;
    padding-bottom:18px;
`;

export const TargetValueType = {
	Primary:"primary",
	Secondary:"secondary"
};
export const LoadingKey = {
	None:"none",
	Main:"main",
	Detail:"detail"
};

const CompareValuePanel = (props)=>{
	const { primaryComponent, secondaryComponent } = props;
	const canEnterThisRoute = RouteUtil.CheckRoutePermission(true);
	return <ComparePanel 
		{...props}
		showHeaderOptionBar={canEnterThisRoute}
	>
		{({showCompare})=>{
    		const marginSize = parseInt(Metrics.button.bigSpaceMargin * (showCompare ? 0.5 : 0),10);
			const width = showCompare ? "calc(50% - 20px)" : "100%";
			if(canEnterThisRoute){
				return(
					 <div style={{width:"100%", paddingTop:Metrics.button.bigSpaceMargin, display: showCompare ? "inline-flex" : "block"}}>
						<div style={{marginRight:marginSize, width}}>
							{primaryComponent}
						</div>
						{showCompare ? <Divider style={{height:"auto"}} type="vertical" /> : undefined}
						{showCompare ? 
							<div style={{marginLeft:marginSize, width}}>
								{secondaryComponent}
							</div> : undefined}
					</div>
				);
			}
			return <UpgradePlanWarning/>;
		}}
	</ComparePanel>;
};

export default CompareValuePanel;


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/CompareValuePanel.js